export default {
  showImportModal: (state) => {
    return state.showImportModal;
  },
  showMapSearch: (state) => {
    return state.showMapSearch;
  },
  showAddPointModal: (state) => {
    return state.showAddPointModal;
  },
  showZoomToLocationModal: (state) => {
    return state.showZoomToLocationModal;
  },
  getAccessFlags: (state) => {
    return state.accessFlags;
  },
};
